/**
 * DM-10753: /timeline no longer carries the html behind AI overviews and
 * People-Also-Ask answers (it was 96% of a 30-day response). Those items
 * carry `hasHtml` instead, and the html is fetched per poll from
 * /timeline/html when a dialog is opened. One fetch per poll: the AI-overview
 * and the PAA box of the same card share it, and reopening is instant.
 */

const cache = new Map();
// A poll's html runs to ~1 MB; keep the most recent few dozen, far more than one screen of cards.
const CACHE_MAX = 30;

/** The poll a card's details come from: a news card shows its term's regular
 *  Google poll (DM-10315) and a copied card keeps the source poll's id. */
export function detailsPollid(cardMeta, view) {
  const source = view === "timelineNews" ? cardMeta?.serpPollid : cardMeta?.pollid;
  return source ? String(source).replace(/-copied-.*/, "") : null;
}

/** Resolves to { aioverview, question[] } for the poll; cached per poll and client. */
export function loadResultHtml(api, pollid, clientid) {
  const key = `${clientid}:${pollid}`;
  if (!cache.has(key)) {
    const pending = api.getTimelineHtml(pollid, clientid)
      .then((response) => response.data)
      .catch((error) => {
        cache.delete(key); // a failed fetch must not stick
        throw error;
      });
    cache.set(key, pending);
    if (cache.size > CACHE_MAX) {
      cache.delete(cache.keys().next().value); // Map keeps insertion order: the oldest goes
    }
  }
  return cache.get(key);
}

export function clearResultHtmlCache() {
  cache.clear();
}
